// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Releases.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  ActivateReleaseRequest,
  ActivateReleaseResponse,
  CreateReleaseRequest,
  CreateReleaseResponse,
  GetActiveReleaseRequest,
  GetActiveReleaseResponse,
  GetReleasesRequest,
  GetReleasesResponse,
  TriggerReleaseRequest,
  TriggerReleaseResponse,
} from "./Models/ReleaseModels";

export const protobufPackage = "daisi.protos.v1";

export type ReleasesProtoDefinition = typeof ReleasesProtoDefinition;
export const ReleasesProtoDefinition = {
  name: "ReleasesProto",
  fullName: "daisi.protos.v1.ReleasesProto",
  methods: {
    create: {
      name: "Create",
      requestType: CreateReleaseRequest,
      requestStream: false,
      responseType: CreateReleaseResponse,
      responseStream: false,
      options: {},
    },
    getReleases: {
      name: "GetReleases",
      requestType: GetReleasesRequest,
      requestStream: false,
      responseType: GetReleasesResponse,
      responseStream: false,
      options: {},
    },
    getActiveRelease: {
      name: "GetActiveRelease",
      requestType: GetActiveReleaseRequest,
      requestStream: false,
      responseType: GetActiveReleaseResponse,
      responseStream: false,
      options: {},
    },
    activate: {
      name: "Activate",
      requestType: ActivateReleaseRequest,
      requestStream: false,
      responseType: ActivateReleaseResponse,
      responseStream: false,
      options: {},
    },
    triggerRelease: {
      name: "TriggerRelease",
      requestType: TriggerReleaseRequest,
      requestStream: false,
      responseType: TriggerReleaseResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface ReleasesProtoServiceImplementation<CallContextExt = {}> {
  create(
    request: CreateReleaseRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateReleaseResponse>>;
  getReleases(
    request: GetReleasesRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetReleasesResponse>>;
  getActiveRelease(
    request: GetActiveReleaseRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetActiveReleaseResponse>>;
  activate(
    request: ActivateReleaseRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ActivateReleaseResponse>>;
  triggerRelease(
    request: TriggerReleaseRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<TriggerReleaseResponse>>;
}

export interface ReleasesProtoClient<CallOptionsExt = {}> {
  create(
    request: DeepPartial<CreateReleaseRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateReleaseResponse>;
  getReleases(
    request: DeepPartial<GetReleasesRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetReleasesResponse>;
  getActiveRelease(
    request: DeepPartial<GetActiveReleaseRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetActiveReleaseResponse>;
  activate(
    request: DeepPartial<ActivateReleaseRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ActivateReleaseResponse>;
  triggerRelease(
    request: DeepPartial<TriggerReleaseRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<TriggerReleaseResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
